var _circle, _circle2, _rect, _circle3, _path, _path2, _path3, _path4, _path5, _g, _g2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelfie = function SvgSelfie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Selfie_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Selfie_svg__a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 50,
    y: -4,
    width: 45,
    height: 49,
    rx: 2,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 5.5,
    cy: 63.5,
    r: 19.5,
    stroke: "#000",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.752 44.722c8.17 0 14.792-6.653 14.792-14.86C56.544 21.653 49.922 15 41.753 15c-8.17 0-14.792 6.654-14.792 14.861 0 8.208 6.622 14.861 14.791 14.861Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.752 42.722c8.17 0 14.792-6.653 14.792-14.86C54.544 19.653 47.922 13 39.753 13c-8.17 0-14.792 6.654-14.792 14.861 0 8.208 6.622 14.861 14.791 14.861Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.362 51.124a27.703 27.703 0 0 0-17.547 9.43 28.192 28.192 0 0 0-6.811 18.849v71.514c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.363 2.66 8.959 8.959 0 0 0 6.364-2.66 9.128 9.128 0 0 0 2.635-6.423v-9.083c0-2.409.949-4.719 2.636-6.423a8.959 8.959 0 0 1 6.364-2.66 8.96 8.96 0 0 1 6.363 2.66 9.128 9.128 0 0 1 2.636 6.423v9.083c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.364 2.66 8.959 8.959 0 0 0 6.363-2.66A9.128 9.128 0 0 0 71 150.917V78.252a27.525 27.525 0 0 0-2.331-11.032 27.3 27.3 0 0 0-6.55-9.14 27.002 27.002 0 0 0-9.651-5.689 26.823 26.823 0 0 0-11.106-1.267Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.362 47.124a27.703 27.703 0 0 0-17.547 9.43 28.192 28.192 0 0 0-6.811 18.849v71.514c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.363 2.66 8.959 8.959 0 0 0 6.364-2.66 9.128 9.128 0 0 0 2.635-6.423v-9.083c0-2.409.949-4.719 2.636-6.423a8.959 8.959 0 0 1 6.364-2.66 8.96 8.96 0 0 1 6.363 2.66 9.128 9.128 0 0 1 2.636 6.423v9.083c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.364 2.66 8.959 8.959 0 0 0 6.363-2.66A9.128 9.128 0 0 0 67 146.917V74.252a27.525 27.525 0 0 0-2.331-11.032 27.3 27.3 0 0 0-6.55-9.14 27.002 27.002 0 0 0-9.651-5.689 26.823 26.823 0 0 0-11.106-1.267Z",
    fill: "#EDE3D5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Selfie_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 47,
    width: 54,
    height: 109
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.362 47.124a27.703 27.703 0 0 0-17.547 9.43 28.192 28.192 0 0 0-6.811 18.849v71.514c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.363 2.66 8.959 8.959 0 0 0 6.364-2.66 9.128 9.128 0 0 0 2.635-6.423v-9.083c0-2.409.949-4.719 2.636-6.423a8.959 8.959 0 0 1 6.364-2.66 8.96 8.96 0 0 1 6.363 2.66 9.128 9.128 0 0 1 2.636 6.423v9.083c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.364 2.66 8.959 8.959 0 0 0 6.363-2.66A9.128 9.128 0 0 0 67 146.917V74.252a27.525 27.525 0 0 0-2.331-11.032 27.3 27.3 0 0 0-6.55-9.14 27.002 27.002 0 0 0-9.651-5.689 26.823 26.823 0 0 0-11.106-1.267Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Selfie_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 46.49a18.28 18.28 0 0 0 6.473 6.246A17.264 17.264 0 0 0 40 55c2.977 0 5.908-.778 8.527-2.264A18.28 18.28 0 0 0 55 46.49a21.352 21.352 0 0 0-7.901-5.194 20.536 20.536 0 0 0-9.255-1.19c-4.865.476-9.413 2.736-12.844 6.384Z",
    fill: "#000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.99 7.98h-4.256c-5.93 0-10.754 4.943-10.754 11.02v6.77c0 1.109.877 2.007 1.959 2.007s1.958-.899 1.958-2.007V19c0-3.863 3.067-7.006 6.837-7.006h4.256c1.082 0 1.959-.898 1.959-2.007 0-1.108-.877-2.007-1.96-2.007ZM18.939 37.204c-1.082 0-1.959.898-1.959 2.007v6.77C16.98 52.058 21.804 57 27.734 57h4.256c1.082 0 1.959-.898 1.959-2.007 0-1.108-.877-2.007-1.96-2.007h-4.255c-3.77 0-6.837-3.143-6.837-7.005v-6.77c0-1.109-.876-2.007-1.958-2.007ZM55.247 7.98H50.99c-1.082 0-1.958.899-1.958 2.007 0 1.109.876 2.007 1.958 2.007h4.257c3.769 0 6.836 3.143 6.836 7.005v6.771c0 1.108.877 2.007 1.959 2.007 1.081 0 1.958-.899 1.958-2.007v-6.771C66 12.923 61.177 7.98 55.247 7.98ZM64.041 37.204c-1.081 0-1.958.898-1.958 2.007v6.77c0 3.862-3.067 7.005-6.836 7.005H50.99c-1.082 0-1.958.899-1.958 2.007 0 1.109.876 2.007 1.958 2.007h4.257C61.177 57 66 52.058 66 45.981v-6.77c0-1.109-.877-2.007-1.959-2.007Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.01 6h-4.257C19.823 6 15 10.943 15 17.019v6.771c0 1.108.877 2.006 1.959 2.006 1.081 0 1.958-.898 1.958-2.006v-6.771c0-3.862 3.067-7.005 6.836-7.005h4.257c1.082 0 1.958-.899 1.958-2.007C31.968 6.898 31.091 6 30.01 6ZM16.959 35.223c-1.082 0-1.959.898-1.959 2.007V44c0 6.077 4.823 11.02 10.753 11.02h4.257c1.082 0 1.958-.899 1.958-2.007 0-1.109-.877-2.007-1.959-2.007h-4.256c-3.769 0-6.836-3.143-6.836-7.005v-6.77c0-1.11-.877-2.008-1.959-2.008ZM53.266 6H49.01c-1.082 0-1.959.898-1.959 2.007 0 1.108.877 2.007 1.959 2.007h4.256c3.77 0 6.837 3.143 6.837 7.005v6.77c0 1.11.876 2.007 1.958 2.007 1.082 0 1.959-.898 1.959-2.006v-6.771C64.02 10.943 59.196 6 53.266 6ZM62.061 35.223c-1.082 0-1.958.898-1.958 2.007V44c0 3.863-3.068 7.006-6.837 7.006H49.01c-1.082 0-1.959.898-1.959 2.007 0 1.108.877 2.007 1.959 2.007h4.256c5.93 0 10.754-4.943 10.754-11.02v-6.77c0-1.108-.877-2.007-1.959-2.007Z",
    fill: "#fff"
  }))));
};
export default SvgSelfie;